import React, {useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom'
import Loading from '../general/Loading';

const ManageStaff = ({setResponse}) => {
    const navigate = useNavigate();
    const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(false);
        const [searchQuery, setSearchQuery] = useState('');
            const [selectedProduct, setSelectedProduct] = useState('');
            const [showDelete, setShowDelete] = useState(false);
        

        useEffect(() => {
            const fetchStaff = async () => {
                setLoading(true);
                try {
                    const response = await fetch('https://api.hargharmart.com/get-staff');
    
                    if (response.ok) {
                        const data = await response.json();
                        setStaff(data);
                        setLoading(false);
                    } else {
                        setLoading(false);
                        console.error('Failed to fetch staff');
                    }
                } catch (error) {
                    setLoading(false);
                    console.error('Error fetching data:', error);
                }
            };
    
            fetchStaff();
        }, []);

            const filterStaff= staff.filter(myItem =>
            (myItem.name?.toLowerCase().includes(searchQuery.toLowerCase()) || '')
        );


            const handleShowDelete = (product) => {
      setSelectedProduct(product);
      setShowDelete(true);
    }

          const handleDelete = async (productId) => {
    try {
      const response = await fetch(`https://api.hargharmart.com/delete-staff/${productId}`, {
        method: 'DELETE',
      });

      if (response.ok) {
setStaff((prevProducts) => prevProducts.filter((product) => product.id !== productId));
        setResponse({ message: 'Staff deleted successfully!', status: 'success' });
        setTimeout(() => {
          setResponse('');
        }, 2000);
        setShowDelete(false);
      } else {
                setResponse({ message: 'Unable to Delete Staff.', status: 'error' });
        setTimeout(() => {
          setResponse('');
        }, 2000);  
      }
    } catch (error) {
      console.error('Error deleting product:', error);
    }
  };


  return (
    <>
                <section className='my-4'>
      <div className='px-4'>
        <div className='d-flex justify-content-between'>
          <p className='page-title'>Manage Staff</p>
          <button className='edit-btn' onClick={() => navigate('/add-staff')}>Add Staff</button>
        </div>

                    <div className='d-flex bg-white rounded-2 py-2 my-3'>
                        <i class="fa-solid fa-magnifying-glass text-darkblue px-2"></i>
                        <input
                            type="text"
                            className="profile-control rounded-2 border-0 bg-white w-100 py-0"
                            placeholder="Search By Name"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>

<div className='row'>
              {filterStaff.map(staff => (
                <div className='col-xl-4 col-lg-6 col-md-6 mb-3'>
                  <div className='user-area'>

<div>
<p className='fw-semibold'>{staff.name} ({staff.role})</p>
<p className='para-text mb-0'>
  Mobile No: {staff.mobile}<br />
  Password: {staff.pass}<br />
  Permissions:{' '}
  {Array.isArray(staff.permission)
    ? staff.permission.join(', ')
    : (() => {
        try {
          const parsed = JSON.parse(staff.permission);
          return Array.isArray(parsed) ? parsed.join(', ') : staff.permission;
        } catch {
          return staff.permission;
        }
      })()}
</p>

</div>

<div className='my-3'>
<span className='edit-btn' onClick={() => navigate('/edit-staff', { state: { staff: staff } })}>Edit Staff</span>&nbsp;&nbsp;
<span className='close-btn' onClick={() => handleShowDelete(staff)}>Remove</span>    
    </div>

</div>
</div>

              ))}
</div>
{/* row ends */}



</div>
</section>

{showDelete && (
  <>
                                  <section className="detail-dialog animate__animated animate__zoomIn px-2">
                                    <div className='detail-dialog-inner text-center col-lg-4 col-11 mx-auto px-lg-5 py-lg-5 px-3 py-3'>

<p className='page-title fs-6'>Want to Remove '{selectedProduct.name}'?</p>

<button className='edit-btn' onClick={() => handleDelete(selectedProduct.id)}>Yes</button>&nbsp;&nbsp;
<button className='close-btn' onClick={() => setShowDelete(false)}>No</button>

</div>
</section>
  </>
)}

    </>
  )
}

export default ManageStaff
